import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { RecruitingService } from 'src/app/recruiting/recruiting.service';

@UntilDestroy()
@Component({
    selector: 'nova-open-tickets',
    templateUrl: './open-tickets.component.html',
    styleUrls: ['./open-tickets.component.scss'],
    standalone: true,
    imports: [CommonModule, MatIconModule, MatMenuModule]
})
export class OpenTicketsComponent implements OnInit {
    @Input() asList = false;

    @Input() candidateId: number;
    @Output() ticketSelected: EventEmitter<boolean> = new EventEmitter<boolean>();

    openTickets: any[] = [];

    openTicketCount = 0;
    constructor(private readonly recruitingService: RecruitingService) {}

    ngOnInit(): void {
        if (this.asList) {
            this.recruitingService
                .GetCandidateOpenTickets(this.candidateId)
                .pipe(untilDestroyed(this))
                .subscribe({
                    next: (tickets) => {
                        this.openTickets = tickets;
                    },
                    error: (err) => {
                        console.error(err);
                    }
                });
        } else {
            this.recruitingService
                .getOpenTicketsCount(this.candidateId)
                .pipe(untilDestroyed(this))
                .subscribe({
                    next: (tickets) => {
                        this.openTicketCount = tickets ? tickets : 0;
                    },
                    error: (err) => {
                        console.error(err);
                    }
                });
        }
    }

    onTicketSelected(): void {
        this.ticketSelected.emit(true);
    }
}
